import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ranks"
  }, [_c('m-head'), _c('div', {
    staticClass: "ranks-main page-main"
  }, [_vm.activityInfo && _vm.activityInfo?.img ? _c('div', {
    staticClass: "ranks-banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.activityInfo.img,
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ranks-tab"
  }, [_c('m-tab-two', {
    attrs: {
      "tab": _vm.tabList,
      "selectTab": _vm.selectTab
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      },
      "tabFn": _vm.onTab
    }
  })], 1), _c('div', {
    staticClass: "ranks-more"
  }, [_c('div', {
    ref: "scrollContainer",
    staticClass: "ranks-more-times"
  }, _vm._l(_vm.activityInfoList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranks-more-times-item",
      class: _vm.selectActivityTime == index && 'active',
      on: {
        "click": function ($event) {
          return _vm.onSelectActivityTime(item, index);
        }
      }
    }, [_c('div', {
      staticClass: "ranks-more-times-item__label"
    }, [_vm._v(_vm._s(_vm.fmt_time(item.start_time).format("MM.DD")) + "-" + _vm._s(_vm.fmt_time(item.end_time).format("MM.DD")))]), _c('div', {
      staticClass: "ranks-more-times-item__status"
    }, [item.activity_status === 0 ? _c('span', {
      staticStyle: {
        "color": "#bdbdbd"
      }
    }, [_vm._v("Not started")]) : item.activity_status === -1 ? _c('span', {
      staticStyle: {
        "color": "#494949"
      }
    }, [_vm._v("Finished")]) : item.activity_status === 1 ? _c('span', {
      staticStyle: {
        "color": "#4CAF50"
      }
    }, [_vm._v("In progress")]) : _vm._e()])]);
  }), 0), _vm.activityInfo && !_vm.isPage ? _c('div', {
    staticClass: "ranks-more__sub"
  }, [_vm._v(_vm._s(_vm.activityInfo.des))]) : _vm._e()]), !_vm.isPage ? [_vm.activityRewards && _vm.activityRewards?.length ? _c('div', {
    staticClass: "ranks-reward"
  }, [_c('div', {
    staticClass: "ranks-reward-main"
  }, _vm._l(_vm.activityRewards, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranks-reward-item"
    }, [_c('div', {
      staticClass: "ranks-reward-item-main"
    }, [_c('div', {
      staticClass: "ranks-reward-base"
    }, [_c('div', {
      staticClass: "ranks-reward-item__icon"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-giftshare.png'),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "ranks-reward-item__label"
    }, [_vm._v("x" + _vm._s(item.token))])]), item.sort >= 4 ? _c('div', {
      staticClass: "ranks-rewards__info"
    }, [_vm._v(_vm._s(item.sort) + "th Place")]) : _c('div', {
      staticClass: "ranks-rewards__info"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/rank-${Number(item.sort)}.png`),
        "alt": ""
      }
    }), _vm._v(" Place")])])]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "ranks-btns"
  }, [_vm.selectTab.value == 0 ? _c('div', {
    staticClass: "btn",
    on: {
      "click": () => _vm.$router.push('/rewards')
    }
  }, [_vm._v("Collecting Energy")]) : _vm.selectTab.value == 1 ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Invite friends")]) : _vm._e()]), _vm.activityInfo && _vm.activityInfo.activity_status == -1 ? [_vm.activityInfo.is_award === 0 ? _c('div', {
    staticClass: "ranks-info"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-tip"
    }
  }), _vm._v(" The reward has not been issued yet. Please wait patiently.")], 1) : _vm.activityInfo.is_award === 1 ? _c('div', {
    staticClass: "ranks-info ok"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-ok-fill"
    }
  }), _vm._v("Rewards have been issued, thank you for participating")], 1) : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "ranks-list"
  }, [_vm.activityRaning ? _vm._l(_vm.activityRaning, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranks-item"
    }, [_c('div', {
      staticClass: "ranks-item__img"
    }, [_c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "ranks-item-info"
    }, [_c('div', {
      staticClass: "ranks-item__name"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "ranks-item__num"
    }, [_vm.selectTab.value == 0 ? _c('img', {
      attrs: {
        "src": require('@images/icon-stock.png'),
        "alt": ""
      }
    }) : _vm.selectTab.value == 1 ? _c('img', {
      attrs: {
        "src": require('@images/icon-firend.png'),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(_vm.fmt_pre(item.num)) + " ")])]), index >= 3 ? _c('div', {
      staticClass: "ranks-item__r"
    }, [_vm._v("#" + _vm._s(index + 1))]) : _c('div', {
      staticClass: "ranks-item__r"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/rank-${index + 1}.png`),
        "alt": ""
      }
    })])]);
  }) : _vm._e()], 2), _vm.activityRaningUser && _vm.activityRaning && _vm.activityRaning.length > 0 ? _c('div', {
    staticClass: "ranks-item user"
  }, [_c('div', {
    staticClass: "ranks-item__img"
  }, [_c('m-head-img', {
    attrs: {
      "name": _vm.userInfo,
      "bgColor": _vm.userInfo.head_color
    }
  })], 1), _c('div', {
    staticClass: "ranks-item-info"
  }, [_c('div', {
    staticClass: "ranks-item__name"
  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _c('div', {
    staticClass: "ranks-item__num"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-stock.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.activityRaningUser.num)))])]), [_vm.activityRaningUser.rank === 1 || _vm.activityRaningUser.rank === 2 || _vm.activityRaningUser.rank === 3 ? _c('div', {
    staticClass: "ranks-item__r"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/rank-${_vm.activityRaningUser.rank}.png`),
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "ranks-item__r"
  }, [Number(_vm.activityRaningUser.rank) === NaN ? [_vm._v("#")] : _vm._e(), _vm._v(_vm._s(_vm.activityRaningUser.rank))], 2)]], 2) : _vm._e()] : [_vm._m(0)]], 2), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };